export default [
  {
    path: '/app/projects',
    name: 'Projects',
    component: () => import('@/views/Admin/Projects/Index.vue'),
    meta: {
      pageTitle: 'Projeler',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_PROJECT_LIST',
      action: 'read',
    },
  },
  {
    path: '/app/projects/add',
    name: 'ProjectAdd',
    component: () => import('@/views/Admin/Projects/Add.vue'),
    meta: {
      pageTitle: 'Projects',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/projects',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_PROJECT_ADD',
      action: 'read',
    },
  },
  {
    path: '/app/projects/edit/:id',
    name: 'ProjectEdit',
    component: () => import('@/views/Admin/Projects/Edit.vue'),
    meta: {
      pageTitle: 'Projeler',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/projects',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_PROJECT_EDIT',
      action: 'read',
    },
  },
]
